export class Personne {
    id: number;
    nom: string;
    prenom: string;
    email: string;
    telephone: string;
    fonction: string;
    civilite: string;
}
